/* eslint-disable spaced-comment */
/* eslint-disable max-len */
import React from 'react';

import Card from './Card';
import './App.scss';

/*
  eslint react/jsx-one-expression-per-line: 0
*/

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = { activityType: null };
    this.selectAppointmentType = this.selectAppointmentType.bind(this);
  }

  selectAppointmentType(type) {
    this.setState({ activityType: type });
  }

  render() {
    const { activityType } = this.state;
    return (
      <div className="App">
        <div className="k-card-container">
          {/*<Card
            name="Post Completion OPT Application Appointment"
            location="Virtual"
            sessionType="OPT"
            active={activityType === 'Post Completion OPT Application Appointment'}
            inactive={!!activityType && activityType !== 'Post Completion OPT Application Appointment'}
            onButtonClick={this.selectAppointmentType}
          >
            <p>If you have reviewed the information about <a href="http://www.bu.edu/isso/employment-internships/student-off-campus-work-and-training/optional/applying-for-opt/" rel="noreferrer noopener">applying for OPT</a> and are ready to apply for post-completion OPT</p>
    </Card> */}
          <Card
            name="15-Minute Advising Appointment"
            location="Virtual"
            sessionType="15-minute"
            active={activityType === '15-Minute Advising Appointment'}
            inactive={!!activityType && activityType !== '15-Minute Advising Appointment'}
            onButtonClick={this.selectAppointmentType}
          >
            <p>For quick questions regarding topics such as:</p>
            <ul>
              <li>Maintaining Valid Status</li>
              <li>Travel and Visas</li>
              <li>Basic Employment Questions</li>
              <li>Transferring to Another School</li>
              <li>Full-time Enrollment</li>
              <li>Not sure where to start?</li>
            </ul>
          </Card>
          <Card
            name="30-Minute Advising Appointment"
            location="Virtual"
            sessionType="30-minute"
            active={activityType === '30-Minute Advising Appointment'}
            inactive={!!activityType && activityType !== '30-Minute Advising Appointment'}
            onButtonClick={this.selectAppointmentType}
          >
            <p>For complex questions regarding topics such as: </p>
            <ul>
              <li>Health, academic or legal issues</li>
              <li>Changing to / from another status</li>
              <li>CPT / OPT / STEM OPT eligibility and questions</li>
              <li>Leave of absence / interruption of study</li>
              <li>Study abroad</li>
              <li>J-1 student Academic Training (AT)</li>
              <li>Pre-Completion OPT</li>
              <li>STEM OPT application questions</li>
            </ul>
            <p>This appointment type is not designed for you to learn general information about OPT or STEM OPT. If this is your goal, please review our extensive resources on <a href="http://www.bu.edu/isso/employment-internships/student-off-campus-work-and-training/optional/applying-for-opt/">applying for OPT</a> or <a href="http://www.bu.edu/isso/employment-internships/student-off-campus-work-and-training/24-month-stem-opt/applying/">applying for STEM OPT</a>. If you still have additional questions after reviewing these materials, please schedule an advising appointment.</p>
          </Card>
          {/*<Card
            name="STEM OPT Application Appointment"
            location="Virtual"
            sessionType="STEM OPT"
            active={activityType === 'STEM OPT Application Appointment'}
            inactive={!!activityType && activityType !== 'STEM OPT Application Appointment'}
            onButtonClick={this.selectAppointmentType}
          >
            <p>If you have reviewed the information about <a href="http://www.bu.edu/isso/employment-internships/student-off-campus-work-and-training/24-month-stem-opt/applying/" rel="noreferrer noopener">applying for STEM OPT</a> and are ready to apply for the STEM OPT extension</p>
          </Card>*/}
          { /* <div className="k-card in-person">
            <div className="k-card-title">
              <div className="location">
                In Person<span className="icon">&#59088;</span>
              </div>
              I-9 Processing Appointment
            </div>
            <div className="k-card-body">
              // eslint-disable-next-line max-len
              <p>This appointment allows ISSO to complete section 2 of the <a href="/isso/employment-internships/employment-at-bu/">I-9 employment eligibility verification</a> for students hired into new on-campus jobs. Students must <a href="/isso/employment-internships/on-campus-student-employment/on-campus-jobs/">secure on-campus employment</a> and be registered for <a href="/isso/immigration-status/maintaining-status/courseload/">full-time study</a> in the current or following semester to be eligible for on-campus employment. New students must be in the US to complete <em><a href="/isso/getting-started/checking-in-with-isso/">Initial ISSO Check-in</a> </em>before completing the I-9.</p>
              <a className="k-button" href="https://calendly.com/buisso-student-employment/i-9-processing">Schedule</a>
            </div>
    </div>
          <div className="k-card in-person">
            <div className="k-card-title">
              <div className="location">
                In Person<span className="icon">&#59088;</span>
              </div>
              I-20 or DS-2019 Travel Signature Appointment
            </div>
            <div className="k-card-body">
              <p>This appointment allows students to request an on the spot signature for re-entry to the US on their I-20 or DS-2019 immigration document. See more <a href="/isso/travel-visas/u-s-re-entry-documentation/">details</a> about travel signatures and the documentation required to return to the US after international travel.</p>
              <p>Travel signatures via appointment are only available to current students with an on-campus L<em>f</em>A indictor who can present a green badge demonstrating they are cleared to visit campus. Students studying remotely or students who are not cleared to visit campus should email their&nbsp;<a href="/isso/contact/student-advising/" target="_blank" rel="noopener noreferrer" data-auth="NotApplicable">ISSO advisor</a>&nbsp;to request a new I-20 with a new travel signature or seek assistance through a virtual appointment.</p>
              <a className="k-button" href="https://calendly.com/buissostudent/studenttravelsignature">Schedule</a>
            </div>
          </div>
          */ }
        </div>
      </div>
    );
  }
}

export default App;
